export default function turncatText(text,maxLength){
    return text.length > maxLength ? text.slice(0,maxLength) + '...' : text;
}